import React from 'react';
import { PropTypes } from 'prop-types';
import Game from './DashboardGame';

const styles = {
  games: {
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto'
  }
};

const DashboardGame = ({ games }) => (
  <div style={styles.games}>
    {games
      .sortBy(x => x.get('date'))
      .reverse()
      .entrySeq()
      .map(([key, game]) => (
        <Game
          key={key}
          game={game}
          startCodingLink={`/games/${key}/code`}
          gameDetailsLink={`/games/${key}/details`}
        />
      ))}
  </div>
);

DashboardGame.propTypes = {
  games: PropTypes.object.isRequired
};

export default DashboardGame;



// WEBPACK FOOTER //
// ./src/routes/home/components/DashboardGames.js